import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import LabelDescription from '../LabelDescription';
import OutputNumberUnit from '../OutputNumberUnit';
import ProductionFixedCostsLayout from '../ProductionFixedCostsLayout';

class ProductionFixedCosts extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		const { game } = this.props;
		const { viewMode } = game;
		const {
			machines,
			machineCost,
			machinesTotalCost,

			machineryDepreciation,
			totalBuildings,
			buildingRentUnit,
			buildingRentTotal,
			qualityCheckPersonelTotalCosts,
			qualityCheckPersonelDepreciation,
			recyclingAndWasteManagementTotalCosts,
			qualityMaintenanceTotalCosts,
			juiceTasterTotalCost,
			chemicalExpertTotalCost,
			qualityTotalCosts
		} = game.production;

		const variables = [
			{
				id: 'machinery-depreciation',
				value: machineryDepreciation,
				unit: '€/yr',
				black: true
			},
			{ id: 'total-buildings', value: totalBuildings, unit: '' },
			{ id: 'building-rent-unit', value: buildingRentUnit, unit: '€/yr' },
			{
				id: 'building-rent-total',
				value: buildingRentTotal,
				unit: '€/yr',
				black: true
			},
			{
				id: 'quality-check-personel-total-costs',
				description: 'quality-check-personel-total-costs-desc',
				value: qualityCheckPersonelTotalCosts,
				unit: '€'
			},
			{
				id: 'quality-check-personel-depreciation',
				value: qualityCheckPersonelDepreciation,
				unit: '€'
			},
			{
				id: 'recycling-and-waste-management-total-costs',
				value: recyclingAndWasteManagementTotalCosts,
				unit: '€'
			},
			{
				id: 'quality-maintenance-total-costs',
				value: qualityMaintenanceTotalCosts,
				unit: '€'
			},
			{ id: 'juice-taster-total-cost', value: juiceTasterTotalCost, unit: '€' },
			{
				id: 'chemical-expert-total-cost',
				value: chemicalExpertTotalCost,
				unit: '€'
			},
			{
				id: 'quality-total-costs',
				value: qualityTotalCosts,
				unit: '€',
				black: true
			}
		];

		return (
			<div className="production-quality-check">
				<ProductionFixedCostsLayout>
					<BusinessPlanSubSectionTitle label={'production-fixed-costs-title'} />
					<ProductionFixedCostsLayout.Header>
						<ProductionFixedCostsLayout.HeaderItem
							label={'fixed-costs-machines'}
							variable={machines}
						/>
						<ProductionFixedCostsLayout.HeaderItem
							label={'fixed-costs-machines-cost'}
							variable={machineCost}
							unit={'€'}
						/>
						<ProductionFixedCostsLayout.HeaderItem
							label={'fixed-costs-machines-total-cost'}
							variable={machinesTotalCost}
							unit={'€'}
						/>
					</ProductionFixedCostsLayout.Header>
				</ProductionFixedCostsLayout>
				<BusinessPlanSubSectionTitle
					label={'production-line-depreciation-title'}
				/>
				<ThreeYearsTableLayout>
					<Header />
					{variables.map(variable => (
						<Row key={variable.id} black={variable.black}>
							<Label>
								<LabelDescription
									label={variable.id}
									description={variable.description}
								/>
							</Label>
							{range(1, 4).map(n => (
								<Col key={n}>
									<OutputNumberUnit
										active={!viewMode}
										variable={variable.value[n - 1]}
										unit={variable.unit}
									/>
								</Col>
							))}
						</Row>
					))}
				</ThreeYearsTableLayout>
			</div>
		);
	}
}

ProductionFixedCosts.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		production: PropTypes.shape({
			machines: PropTypes.object,
			machineCost: PropTypes.object,
			machinesTotalCost: PropTypes.object,
			machineryDepreciation: MultiYearScalarType,
			totalBuildings: MultiYearScalarType,
			buildingRentUnit: MultiYearScalarType,
			buildingRentTotal: MultiYearScalarType,
			qualityCheckPersonelTotalCosts: MultiYearScalarType,
			qualityCheckPersonelDepreciation: MultiYearScalarType,
			recyclingAndWasteManagementTotalCosts: MultiYearScalarType,
			qualityMaintenanceTotalCosts: MultiYearScalarType,
			juiceTasterTotalCost: MultiYearScalarType,
			chemicalExpertTotalCost: MultiYearScalarType,
			qualityTotalCosts: MultiYearScalarType
		})
	})
};

export default ProductionFixedCosts;
